import React, { useContext, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import Auth from "../../Redux/Actions/Auth";
import ApiAuth from "../../API/ApiAuth";
import { getPageTitle } from "../../Redux/variables";
import { AuthContext } from "../../context/AuthContext";
import Headerbar from "../../components/NavHeader";
import PageHeader from "../../components/PageHeader";
import ScrollButton from "../../components/scrollButton/ScrollButton";
import LoginButton from "../../components/loginButton";

const ForgetPassword = (props) => {
  const { currentUser } = useContext(AuthContext);
  const dispatch = useDispatch();

  const [forgetInVisible, setForgetInVisible] = useState(false);
  const [forgetSubmitInVisible, setForgetSubmitInVisible] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");
  const [forgetPassword, setForgetPassword] = useState("");
  const [forgetCode, setForgetCode] = useState("");

  const forgetSubmit = useRef(null);
  const forgetSubmitSave = useRef(null);

  const handleForgetSubmit = async (e) => {
    e.preventDefault();
    forgetSubmit.current.innerHTML = "Please wait ...";
    forgetSubmit.current.disabled = true;
    dispatch(Auth.loader(true));

    try {
      const response = await ApiAuth.forgetPassword({ email: forgetEmail });
      const { message, success } = response.data;
      if (success === true) {
        toast.success(message);
        setForgetInVisible(false);
        setForgetSubmitInVisible(true);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error,'error error');
      toast.error(error || "Something went wrong.");
    } finally {
      forgetSubmit.current.innerHTML = "Reset Password";
      forgetSubmit.current.disabled = false;
      dispatch(Auth.loader(false));
    }
  };

  const handleForgetSubmitPost = async (e) => {
    e.preventDefault();
    forgetSubmitSave.current.innerHTML = "Please wait ...";
    forgetSubmitSave.current.disabled = true;
    dispatch(Auth.loader(true));

    try {
      const response = await ApiAuth.forgetPasswordUpdate({
        email: forgetEmail,
        code: forgetCode,
        password: forgetPassword,
      });

      const { message, success } = response;
      if (success === true) {
        toast.success(message);
        props.history.push("/");
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error,'error error');
      toast.error(error || "Something went wrong.");
    } finally {
      forgetSubmitSave.current.innerHTML = "Save";
      forgetSubmitSave.current.disabled = false;
      dispatch(Auth.loader(false));
    }
  };

  if (currentUser) return <Redirect to="/map" />;

  return (
    <>
      <Helmet>
        <title>Home {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`Home | ${getPageTitle()}`} />
        <meta property="og:description" content="" />
        <meta property="og:url" content="https://www.propsure.com.pk/" />
        <meta property="og:site_name" content="PropSure" />
        <meta property="article:publisher" content="" />
        <meta property="og:image" content="" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <Headerbar />
      <PageHeader title="Forget Password" />

      <div className="container services mb-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-8 login-form">
            <div className="card shadow border-0 rounded-3">
              <div className="card-body p-4">
                <h4 className="card-title text-center mb-4" style={{ fontWeight: '600', color: '#00166D' }}>
                  Recover Password
                </h4>

                {!forgetSubmitInVisible && (
                  <form onSubmit={handleForgetSubmit}>
                    <div className="mb-3">
                      <input
                        value={forgetEmail}
                        onChange={(e) => setForgetEmail(e.target.value)}
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div className="mt-3 d-grid">
                      <button
                        className="btn btn-danger waves-effect waves-light pakistan-color"
                        type="submit"
                        ref={forgetSubmit}
                      >
                        Reset Password
                      </button>
                    </div>

                    <div className="mt-3 text-center">
                      <LoginButton {...props} />
                    </div>
                  </form>
                )}

                {forgetSubmitInVisible && (
                  <form onSubmit={handleForgetSubmitPost}>
                    <div className="mb-3">
                      <input
                        value={forgetEmail}
                        onChange={(e) => setForgetEmail(e.target.value)}
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <input
                        value={forgetCode}
                        onChange={(e) => setForgetCode(e.target.value)}
                        type="text"
                        className="form-control"
                        placeholder="Code"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <input
                        value={forgetPassword}
                        onChange={(e) => setForgetPassword(e.target.value)}
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        required
                      />
                    </div>

                    <div className="mt-3 d-grid">
                      <button
                        className="btn btn-danger waves-effect waves-light pakistan-color"
                        type="submit"
                        ref={forgetSubmitSave}
                      >
                        Save
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ScrollButton />
    </>
  );
};

export default ForgetPassword;
